import { isAxiosError } from 'axios'

export function isPlanLimitError(error: unknown): boolean {
	return isAxiosError(error) && error.response?.data?.error === 'plan_limit_reached'
}
